<div>
    <table class="custom-table-list" aria-label="cred_table">
        <thead>
            <tr class="custom-table-list-headings">
                <th class="custom-col-width-30">Department Name</th>
                <th class="custom-col-width-30">User Count</th>
                <th class="custom-col-width-20 th-last">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr class="custom-table-list-row-main" *ngFor="let department of departments">
                <td class="custom-col-width-30">{{ department.name }}</td>
                <td class="custom-col-width-30">{{ department.userCount || "-" }}</td>
                <td class="custom-col-width-20 td-last">
                    <span class="d-flex justify-content-start" *ngIf="hasEditAccess(department)">
                        <span data-bs-toggle="tooltip" ngbTooltip="Edit" [placement]="'left'"
                            (click)="isEditDepartment(department)">
                            <div tooltipClass="custom-tooltip" class="btn btn-primary btn-sm me-2 custom-button">
                                <fa-icon [icon]="faEdit"></fa-icon>
                            </div>
                        </span>
                        <span data-bs-toggle="tooltip" ngbTooltip="DELETE" [placement]="'left'"
                            (click)="deleteDepartment(department)">
                            <div class="btn btn-primary btn-sm me-2 fa-icon-class custom-button">
                                <fa-icon [icon]="faTrash"></fa-icon>
                            </div>
                        </span>
                    </span>
                </td>
            </tr>
            <tr class="custom-table-list-row-main" *ngIf="loadRecords">
                <td class="custom-col-width-100 text-danger d-flex justify-content-center">
                    <app-common-icon [loadingIcon]="loadRecords"></app-common-icon>
                </td>
            </tr>
            <tr *ngIf="departments?.length === 0">
                <td class="custom-col-width-100 text-danger d-flex justify-content-center">
                    No Data Found
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="overlay" [class.show]="openDepartmentPanel"></div>
<div class="off-canvas width-450" *ngIf="openDepartmentPanel" [class.show]="openDepartmentPanel">
    <div class="off-canvas-content">
        <app-add-department [isEdit]="isEdit" [selectedDepartment]="selectedDepartment"
            (successToster)="successTosterFromAddDepartmentComponent($event)"
            (closePanel)="closeDepartmentPanel()"></app-add-department>
    </div>
</div>

<div class="toaster_message" *ngIf="isErrorToster">
    <app-error-toaster [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-error-toaster>
</div>

<div class="toaster_message" *ngIf="isSuccessToster">
    <app-toast [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-toast>
</div>

<div class="footer-page-ination">
    <app-paginator [totalCount]="totalRecords" [showFirstLastIcon]="true" (selectedPage)="onPageChange($event)">
    </app-paginator>
</div>